import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Alert, Box } from '@mui/material';
import MainLayout from '../layout/MainLayout';
import StyledButton from '../common/StyledButton';
import PaymentStep from './steps/PaymentStep';

// Page wrapper that adapts the shared PaymentStep component to the
// "Pay for Selected" entry point on /vendor/dashboard. Booth and vendor
// data are passed via react-router location state by VendorDashboard.
const VendorPaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { boothData, vendorData } = location.state || {};

  // If a user lands here directly (refresh, deep link, etc.) there will
  // be no state. Bounce back to the dashboard rather than rendering a
  // broken PaymentStep that crashes on undefined boothData.
  useEffect(() => {
    if (!boothData || !vendorData) {
      navigate('/vendor/dashboard', { replace: true });
    }
  }, [boothData, vendorData, navigate]);

  if (!boothData || !vendorData) {
    return (
      <MainLayout>
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            We couldn't find the booths you wanted to pay for. Please return to
            your dashboard and select them again.
          </Alert>
          <Box>
            <StyledButton onClick={() => navigate('/vendor/dashboard')}>
              Return to Dashboard
            </StyledButton>
          </Box>
        </Container>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <PaymentStep
          boothData={boothData}
          vendorData={vendorData}
          onBack={() => navigate('/vendor/dashboard')}
          onNext={() =>
            navigate('/vendor/dashboard', {
              state: { paymentStatus: 'succeeded' },
            })
          }
        />
      </Container>
    </MainLayout>
  );
};

export default VendorPaymentPage;
